import styles from './LandingView.module.css'
import TwitterScreenshot from './twitter_equivalent_short.png'
import TwitterMobileScreenshot from './twitter_equivalent_mobile3.png'
import DashboardScreenshot from './dashboard_screenshot.png'
import {
  // CurrencyDollarIcon,
  // EyeIcon,
  // LightningBoltIcon,
  TrashIcon,
  UsersIcon,
  ChartBarIcon,
  DeviceMobileIcon,
  PhotographIcon,
  // ShareIcon,
  SparklesIcon,
  ChatAltIcon,
  // LightningBoltIcon,
  // ReplyIcon,
  // CurrencyDollarIcon,
  // EyeIcon,
  EyeOffIcon,
  // DocumentIcon,
  DocumentSearchIcon,
  // ChevronRightIcon,
} from '@heroicons/react/outline'
// import BlotterIcon from 'components/Icons/BlotterIcon3'
// import CricketIcon from 'components/Icons/Cricket'
// import YourBlogPostHere from 'components/YourBlogPostHere'
// import TwitterIcon from 'components/Icons/Twitter'
import BrowserBarMock from 'components/BrowserBarMock'
// import SubscribeForm from 'components/SubscribeForm'
// import TypeWriter from 'components/TypeWriter'
import Footer from 'components/Footer'
import Image from 'next/image'
import CommentsMobileScreenshot from './blotter_comments_mobile3_lesslessshadow.png'
import CommentsScreenshot from './blotter_comments_screenshot_short.png'
// import MobileMenu from 'components/MobileMenu'
import SplitDisplay from 'components/SplitDisplay'
import NumberIcon from 'components/NumberIcon'
import colors from 'tailwindcss/colors'
import GhostIcon from 'components/Icons/GhostIcon'
import Navigation from 'components/Navigation'
// import Button from 'components/Button'
import LinkButton from 'components/LinkButton'
import BlotterLogo from 'components/BlotterLogo'
import Link from 'components/Link'
// import CycleArrowIcon from 'components/Icons/Arrows/CycleArrow'
// import colors from 'tailwindcss/colors'
// import { isCurrentPath } from 'utilities/url'
// import Image from 'next/image'

const LandingView = () =>
  <div className={styles.landingView}>
    {/* <div aria-hidden='true' className='absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-gray-100' /> */}
    <div className='absolute top-5 left-1 sm:top-2 sm:left-1 ml-2'>
      <BlotterLogo size='small' />
      {/* <BlotterIcon name='heading_mobile' width={32} height={32} />
      <div className='text-sm uppercase text-center mb-3 font-bold text-navy-600'>Blotter</div> */}
    </div>
    <Navigation />

    <main>
      <div className='w-full'>
        <div className='mt-32 text-center mx-auto max-w-[98vw] md:max-w-2xl'>
          <h1 className='text-[8vw] text-navy-500 sm:text-4xl md:text-[3.2rem] tracking-tight !leading-tight px-4 md:px-0'>
            {/* The Blog Comment<br />System That<br />Engages */}
            {/* Blog Comments That<br /><span className='whitespace-nowrap'>
              <em>Work</em> For <TypeWriter words={['Founders', 'Indiehackers', 'Creators']} showsInitialWord />
            </span> */}
            {/* The conversation is on Twitter.<br />
            Now it’s on your blog, too. */}
            {/* Blog comments moved to Twitter.<br />
            Now they’re back on your blog, too. */}
            {/* You didn't add comments to your blog because you love empty comment&nbsp;sections */}
            Wave goodbye to your empty&nbsp;blog&nbsp;comments.
            {/* Say farewell to your empty&nbsp;blog&nbsp;comments. */}
            {/* Wave goodbye to spam. */}
          </h1>
          <h1 className='text-[6vw] mt-6 mb-8 sm:text-4xl md:text-[2rem] text-slate-500 tracking-tight !leading-tight px-4 md:px-0'>
            {/* Blog comments moved to&nbsp;Twitter.<br />
            With Blotter, they’re back on your blog&nbsp;too. */}
            Instant social proof and a sense of community for your blog — plus better SEO — with comments powered by&nbsp;Twitter.
            {/* Blotter replaces broken blog comments with Twitter-powered conversations. */}
            {/* Engage your audience and spread your voice with the <strong>world’s first Twitter-powered blog comment system</strong> */}
          </h1>
          <h1 className='text-[4vw] sm:text-3xl md:text-[1.5rem] mt-6 mb-8 text-slate-500 tracking-tight !leading-tight px-4 md:px-0'>Installs on almost any blog in moments.</h1>
          {/* <p>Blotter is a new kind of blog comment system that is Twitter-powered and focused on conversation.</p> */}
          <div className='relative mt-2 mb-32 mx-auto flex justify-center'>
          <LinkButton
            href='/start'
            variant='medium'
            color='rose'
            className='max-w-md mx-auto text-center'
          >Do you want better blog comments? &raquo;</LinkButton>
          <div className='text-[0.75rem] uppercase absolute -bottom-6 text-sky-700 font-bold left-0 right-0'>
              Start for Free
          </div>
          </div>
        </div>
        <SplitDisplay />
      </div>
      <div className='w-full'>
        <div className='mt-48 lg:mt-96 text-left lg:text-center md:mx-auto max-w-full md:max-w-[80vw] px-4'>
          <p className='mt-8 text-2xl text-[1.75rem] md:text-3xl font-extrabold tracking-tight text-navy-500 px-4'>
          {/* Why Blotter is better than traditional blog comment services */}
          The <span className='text-cerise-600'>3 biggest problems</span> with traditional blog comment services
          </p>





        <div className='mt-12 mx-auto grid gap-5 lg:grid-cols-3  max-w-lg lg:max-w-7xl text-left'>
          {reasons.map((post) => (
            <div key={post.title} className='flex flex-col rounded-lg shadow-lg overflow-hidden border border-slate-200 sm:border-slate-100'>
              <div className='flex-shrink-0 p-8 flex justify-center'>
                { post.icon }
                {/* <img className='h-48 w-full object-cover' src={post.imageUrl} alt=' /> */}
              </div>
              <div className='flex-1 bg-white p-6 flex flex-col justify-between'>
                <div className='flex-1'>
                  <p className='text-sm font-medium text-indigo-600'>
                    {/* <a href={post.category.href} className='hover:underline'> */}
                      {post.name}
                    {/* </a> */}
                  </p>
                  <div className='block mt-2'>
                    <div className='lg:min-h-[240px] xl:min-h-[190px] 2xl:min-h-[160px]'>
                      <div className='text-xl font-semibold text-navy-500'>{post.title}</div>
                      <div className='mt-3 text-base text-gray-500'>{post.description}</div>
                    </div>
                    <div className='mt-3 text-base text-gray-500'>{post.blotterBetter}</div>
                  </div>
                </div>
                {/* <div className='mt-6 flex items-center'>
                  <div className='flex-shrink-0'>
                    <a href={post.author.href}>
                      <span className='sr-only'>{post.author.name}</span>
                      <img className='h-10 w-10 rounded-full' src={post.author.imageUrl} alt=' />
                    </a>
                  </div>
                  <div className='ml-3'>
                    <p className='text-sm font-medium text-gray-900'>
                      <a href={post.author.href} className='hover:underline'>
                        {post.author.name}
                      </a>
                    </p>
                    <div className='flex space-x-1 text-sm text-gray-500'>
                      <time dateTime={post.datetime}>{post.date}</time>
                      <span aria-hidden='true'>&middot;</span>
                      <span>{post.readingTime} read</span>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          ))}
        </div>






          {/* <ul className='my-4 px-6 mx-2 text-left'>
            <li className='my-2'><NumberIcon>1</NumberIcon> <strong>The Cold Start</strong>: Empty comment sections frighten off potential commenters</li>
            <li className='my-2'><NumberIcon>2</NumberIcon> <strong>The Spam-to-Signal ratio</strong>: Real commenters are scared off by spam</li>
            <li className='my-2'><NumberIcon>3</NumberIcon> <strong>The Dead-end comment</strong>: One-off comments don’t spark conversation</li>
          </ul> */}
        </div>
      </div>
      <div className='w-full'>
        <div className='mt-48 lg:mt-96 text-center md:mx-auto max-w-[98vw] md:max-w-prose'>
          <p className='text-left lg:text-center mt-8 text-2xl text-[1.75rem] md:text-3xl font-extrabold tracking-tight text-navy-500 px-4'>
            Blotter converts your Twitter engagement to <span className='text-cerise-800'>a sense of community</span> on your blog + social proof for each post
          </p>
          <p className='mt-4 px-4 text-lg text-gray-700 text-left'>
            Let’s face it — blog comments <strong>moved to&nbsp;Twitter</strong>.
            With Blotter, they’re back on your blog&nbsp;too.
          </p>
          <p className='mt-4 px-4 text-lg text-gray-700 text-left'>Blotter replaces your traditional blog comment system and connects your blog post to Twitter so that blog comments appear as replies on Twitter, and replies on Twitter appear as blog comments.</p>
          <p className='mt-4 px-4 text-lg text-gray-700 text-left'>Set up takes less than 5 minutes:</p>
          {/* <SubscribeForm className='flex justify-center mt-8' idSuffix='Top' /> */}
          {/* <div className='my-12 w-full flex relative justify-center gap-20'>
            <div className='w-56 font-['Amatic'] text-4xl text-right text-indigo-500'>
              Twitter Replies Are<br />
              Blog Comments
            </div>
            <div className='absolute -top-6 left-0 right-0 flex justify-center'>
              <CycleArrowIcon fill={colors.indigo[500]} />
            </div>
            <div className='w-56 font-['Amatic'] text-4xl text-left text-indigo-500'>
              Blog Comments Are<br />
              Twitter Replies
            </div>
            <div className='absolute -bottom-6 left-0 right-0 flex justify-center transform rotate-180'>
              <CycleArrowIcon fill={colors.indigo[500]} />
            </div>
          </div> */}
          <div className='relative'>
            <LinkButton
              href='/start'
              variant='medium'
              color='rose'
              className='max-w-sm my-8 mx-auto text-center'
            >Add Social Proof to Your Blog &raquo;</LinkButton>
            <div className='text-[0.75rem] uppercase absolute -bottom-6 text-sky-700 font-bold left-0 right-0'>
              Start for free
              {/* — No CC required */}
            </div>
          </div>
        </div>
      </div>


      {/* Logo Cloud */}
      {/* <div className='bg-gray-100'>
        <div className='max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8'>
          <p className='text-center text-sm font-semibold uppercase text-gray-700 tracking-wide'>
            Trusted by over 5 very average small businesses
          </p>
          <div className='mt-6 grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5'>
            <div className='col-span-1 flex justify-center md:col-span-2 lg:col-span-1'>
              <img className='h-12' src='https://tailwindui.com/img/logos/tuple-logo-gray-400.svg' alt='Tuple' />
            </div>
            <div className='col-span-1 flex justify-center md:col-span-2 lg:col-span-1'>
              <img className='h-12' src='https://tailwindui.com/img/logos/mirage-logo-gray-400.svg' alt='Mirage' />
            </div>
            <div className='col-span-1 flex justify-center md:col-span-2 lg:col-span-1'>
              <img
                className='h-12'
                src='https://tailwindui.com/img/logos/statickit-logo-gray-400.svg'
                alt='StaticKit'
              />
            </div>
            <div className='col-span-1 flex justify-center md:col-span-2 md:col-start-2 lg:col-span-1'>
              <img
                className='h-12'
                src='https://tailwindui.com/img/logos/transistor-logo-gray-400.svg'
                alt='Transistor'
              />
            </div>
            <div className='col-span-2 flex justify-center md:col-span-2 md:col-start-4 lg:col-span-1'>
              <img
                className='h-12'
                src='https://tailwindui.com/img/logos/workcation-logo-gray-400.svg'
                alt='Workcation'
              />
            </div>
          </div>
        </div>
      </div> */}

      {/* Alternating Feature Sections */}
      <div className='relative pt-4 pb-32 overflow-hidden'>

      {/* Section -- Objections */}
      <div className='mt-80'>
          <div className='lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-16'>
            <div className='px-4 max-w-xl mx-auto sm:px-6 lg:py-0 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2'>
              <div>
                <div>
                  <span className='h-12 w-12 rounded-md flex items-center justify-center bg-gradient-to-r from-navy-400 to-navy-600'>
                    {/* <TwitterIcon className='h-6 w-6 text-white' fill='white' aria-hidden='true' /> */}
                    <SparklesIcon className='h-6 w-6 text-white' aria-hidden='true' />
                  </span>
                </div>
                <div className='mt-6'>
                  <p className='mt-8 text-2xl text-[1.75rem] md:text-3xl font-extrabold tracking-tight text-navy-500'>
                  Why Blotter is right for&nbsp;you
                  </p>
                  <p className='mt-4 text-lg text-gray-700 mb-8'>
                    Blotter isn’t just a revolutionary way to connect your blog to Twitter. A few of the reasons it’s a better commenting system:
                  </p>

                  <h2 className='mt-8 text-3xl font-extrabold tracking-tight text-navy-500'>
                    <span className='text-cerise-800'>Simple</span> to install
                    {/* <span className='text-cerise-800'>+</span> */}
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  A few clicks in WordPress — or a tiny JS snippet — and Blotter connects your blog to Twitter, and to a better blog comment experience.
                  </p>

                  <h2 className='mt-8 text-3xl font-extrabold tracking-tight text-navy-500'>
                    <span className='text-cerise-800'>SEO</span>-friendly
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  Comments help search engines understand your content. Blotter adds canonical URLs and Google’s latest robots tag to give your page the best results.</p>

                  <h2 className='mt-8 text-3xl font-extrabold tracking-tight text-navy-500 relative'>
                    <span className='text-cerise-800'>Customizable</span> Design
                    {/* <span className='text-cerise-800'>+</span> */}
                    <span className='absolute text-slate-600 text-sm right-0 -top-4 sm:top-2'>Coming Soon!</span>
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  You do <em>you</em>. Comment systems shouldn’t force you to use <em>their</em> look. Blotter offers designs to pick from, plus customization.</p>

                  <h2 className='mt-8 text-3xl text-[29px] font-extrabold tracking-tight text-navy-500'><span className='text-cerise-800'>Privacy</span>-friendly</h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  Blotter believes in privacy for you, <em>and</em> for your readers. We minimize user data collection and use aggregrate analytics.
                  </p>

                  <h2 className='mt-8 text-3xl text-[29px] font-extrabold tracking-tight text-navy-500'><span className='text-cerise-800'>Fast</span>, Non-blocking Load Time</h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  The faster your page loads, the better. Blotter’s script is small and defers until your page has loaded all of the important stuff.
                  </p>






                  {/* <h3 className='mt-4 text-2xl text-gray-700 font-bold'>Tweets are Comments</h3>
                  <p className='mt-4 text-lg text-gray-700'>
                  When you tweet about your blog posts, <strong>Blotter displays the replies as comments on your blog post.</strong></p>
                  <p className='mt-4 text-lg text-gray-700'>
                  So your blog post comments section <strong>gives your blog a sense of life and community</strong>, instead of seeming like an abandoned ghost town 👻.
                  </p>
                  <h3 className='mt-4 text-2xl text-gray-700 font-bold'>Comments are Tweets</h3>
                  <p className='mt-4 text-lg text-gray-700'>
                  In addition, <strong>comments on your blog show as replies to your&nbsp;Tweet</strong>.
                  </p>
                  <p className='mt-4 text-lg text-gray-700'>
                  So while comment on most blogs lead to dead ends, <strong>comments via Blotter have the potential to be shared with the commenters’ followers</strong> — people more likely to be interested in similar subjects and, therefore, more likely to be intrigued by your blog post.
                  </p> */}




                  {/* <p className='mt-4 text-lg text-gray-700'>
                  With Blotter, each comment is also a reply on Twitter. So each reply has the potential to be shared with the commenter's friends — their followers on Twitter.</EmphasizeText> This sparks additional conversation AND shares your message with people likely to be interested in your niche.
                  </p> */}
                  <div className='mt-6'>
                    <a
                      href='/start'
                      className='inline-flex bg-gradient-to-r from-navy-400 to-navy-600 bg-origin-border px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-indigo-600 hover:to-indigo-800 focus:ring-2 focus:ring-offset-2 focus:ring-navy-400 focus:outline-none'
                    >
                      Get started
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='mt-12 sm:mt-16 lg:mt-0 lg:col-start-1'>
              <div className='hidden md:block mx-auto max-w-[92vw] lg:pt-[82px] lg:relative lg:h-full lg:max-w-[680px]'>
                <BrowserBarMock />
                <img
                  className='w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:h-auto lg:w-[680px]'
                  src={CommentsScreenshot.src}
                  alt='The conversation appears on your blog post'
                />
              </div>
              <div className={styles.screenshotMobile}>
                <Image
                  src={CommentsMobileScreenshot}
                  placeholder='blur'
                  priority
                  alt='The conversation appears on your blog post'
                />
              </div>
            </div>
          </div>
        </div>


        {/* Section -- How Blotter Works */}
        <div className='w-full'>
        <div className='mt-48 lg:mt-80 text-center md:mx-auto max-w-[98vw] md:max-w-prose'>
          <p className='text-left lg:text-center mt-8 text-2xl text-[1.75rem] md:text-3xl font-extrabold tracking-tight text-navy-500 px-4'>
            <span className='text-cerise-800'>How Blotter Works:</span> Conversations Connect Your Blog With Twitter
          </p>

          <div className='mt-4 px-4 gap-4 flex items-center'>
            <NumberIcon className={styles.numberIconLarge}>1</NumberIcon>
            <p className='text-lg text-gray-700 text-left flex-auto'>To install Blotter, add just one plugin or JavaScript snippet to your blog. Blotter works with WordPress, Gatsby, Next.js, or any other blog that accepts a custom JS snippet.</p>
          </div>
          <div className='mt-4 px-4 gap-4 flex items-center'>
            <NumberIcon className={styles.numberIconLarge}>2</NumberIcon>
            <p className='text-lg text-gray-700 text-left flex-auto'>Blotter attaches one or more Twitter threads to each of your blog posts as “Conversations”. Comments on your blog and replies on Twitter stay synced, so readers can join the conversation from either platform. You can <Link href='#how-to-start-a-conversation'>learn more about how Blotter intelligently connects your Twitter threads to the correct blog post</Link>.</p>
          </div>
          <div className='mt-4 px-4 gap-4 flex items-center'>
            <NumberIcon className={styles.numberIconLarge}>3</NumberIcon>
            <p className='text-lg text-gray-700 text-left flex-auto'>You get a sense of community and social proof on your blog, an SEO boost, plus the distribution and network effects of Twitter.</p>
          </div>
        </div>
      </div>


        {/* Section -- Start the Conversation */}
        <div className='mt-80'>
          <div className='lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-16'>
            <div className='px-4 max-w-xl mx-auto sm:px-6 lg:py-0 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-1'>
              <div>
                <div>
                  <span className='h-12 w-12 rounded-md flex items-center justify-center bg-gradient-to-r from-navy-400 to-navy-600'>
                    {/* <TwitterIcon className='h-6 w-6 text-white' fill='white' aria-hidden='true' /> */}
                    <ChatAltIcon className='h-6 w-6 text-white' aria-hidden='true' />
                  </span>
                </div>
                <div className='mt-6'>
                  <h2 className='text-3xl font-extrabold tracking-tight text-navy-500' id='how-to-start-a-conversation'>
                    Start the Conversation
                    {/* <span className='text-cerise-800'>+</span> */}
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                    Unlike traditional blog comment systems, with Blotter you jumpstart the conversation. Three ways to get going:
                  </p>
                  {/* <p className='mt-4 text-lg text-gray-700'>
                    Whether you’re starting a new thread or connecting to a a conversation that is already happening, Blotter makes it easy to banish the empty comment section.
                  </p> */}
                  {/* <p className='mt-4 text-lg text-gray-700'>
                    Three ways Blotter helps jumpstart your blog:
                  </p> */}
                  <h2 className='mt-8 text-3xl text-[29px] font-extrabold tracking-tight text-navy-500'>
                    <span className='text-cerise-800 inline-flex items-center gap-1 align-middle'><NumberIcon>1</NumberIcon> Automatic</span> <span className='align-middle'>Twitter thread matching</span>
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  Already having conversations about your blog posts on Twitter? Blotter automatically connects your blog posts to existing Twitter threads based on the blog post URL.
                  </p>
                  <h2 className='mt-8 text-3xl text-[29px] font-extrabold tracking-tight text-navy-500'>
                    <span className='text-cerise-800 inline-flex items-center gap-1 align-middle'><NumberIcon>2</NumberIcon> Flexible</span> <span className='align-middle'>Twitter thread linking</span>
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  Want to use some other Twitter thread? No problem. Just grab the conversation ID from the Twitter URL and you can connect that thread as a conversation on your blog post.
                  </p>
                  {/* <p className='mt-4 text-lg text-gray-700'>Connect Existing</p> */}
                  <h2 className='mt-8 text-3xl text-[29px] font-extrabold tracking-tight text-navy-500'>
                    <span className='text-cerise-800 inline-flex items-center gap-1 align-middle'><NumberIcon>3</NumberIcon> Easy</span> <span className='align-middle'>Inline Tweet Creation</span>
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                  Need to share more teasers from your blog post to Twitter? (HINT: The answer is *always* yes)
                  </p>
                  <p className='mt-4 text-lg text-gray-700'>
                  Blotter’s embedded Twitter thread crafting tool let’s you craft Tweets while viewing your blog post directly.
                  </p>

                </div>
              </div>
              <div className='mt-6'>
                    <a
                      href='/start'
                      className='inline-flex bg-gradient-to-r from-navy-400 to-navy-600 bg-origin-border px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-indigo-600 hover:to-indigo-800 focus:ring-2 focus:ring-offset-2 focus:ring-navy-400 focus:outline-none'
                    >
                      Get started
                    </a>
                  </div>
            </div>
            <div className='mt-12 sm:mt-16 lg:mt-0 lg:col-start-2'>
              <div className='hidden md:block mx-auto max-w-[92vw] lg:pt-[82px] lg:relative lg:h-full lg:max-w-[680px]'>
                <BrowserBarMock />
                <img
                  className='w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:h-auto lg:w-[680px]'
                  src={TwitterScreenshot.src}
                  alt='The same conversation appears on Twitter'
                />
              </div>
              <div className={styles.screenshotMobile}>
                <Image
                  src={TwitterMobileScreenshot}
                  placeholder='blur'
                  priority
                  alt='The same conversation appears on Twitter'
                />
              </div>
            </div>
          </div>
        </div>


        {/* Section --- Better know your blog posts */}

        <div className='relative'>
          <div className='lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-16 mt-80'>
            <div className='px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2'>
              <div>
                <div>
                  <span className='h-12 w-12 rounded-md flex items-center justify-center bg-gradient-to-r from-navy-400 to-navy-600'>
                    <DocumentSearchIcon className='h-6 w-6 text-white' aria-hidden='true' />
                  </span>
                </div>
                <div className='mt-6'>
                  <h2 className='text-3xl font-extrabold tracking-tight text-navy-500'>
                    Better know your blog posts
                  </h2>
                  <p className='mt-4 text-lg text-gray-700'>
                    Which of your blog posts resonate best with readers?
                  </p>
                  <p className='mt-4 text-lg text-gray-700'>
                    Which of your blog posts do you need to share on Twitter?
                  </p>
                  <p className='mt-4 text-lg text-gray-700'>
                    Blotter’s dashboard shows you at a glance the info you need to know to make the most of the hard work you’ve done to create great content.
                  </p>
                  <div className='mt-6'>
                    <a
                      href='/start'
                      className='inline-flex bg-gradient-to-r from-navy-400 to-navy-600 bg-origin-border px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-indigo-600 hover:to-indigo-800 focus:ring-2 focus:ring-offset-2 focus:ring-navy-400 focus:outline-none'
                    >
                      Get started
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='mt-12 sm:mt-16 lg:mt-0'>
              <div className='pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full'>
                <img
                  className='w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none'
                  src={DashboardScreenshot.src}
                  alt='Dashboard user interface'
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gradient Feature Section */}
      <div className='mt-40 bg-gradient-to-r from-navy-500 to-navy-400'>
        <div className='max-w-4xl mx-auto px-4 py-16 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:pt-24 lg:px-8'>
          <h2 className='text-3xl font-extrabold text-white tracking-tight'>More reasons to use Blotter</h2>
          <p className='mt-4 max-w-3xl text-lg text-purple-200'>
            There are lots of comments systems for your blog. Some of them are even free! So, why would you choose to use Blotter?
          </p>
          <div className='mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16'>
            {benefits.map((feature) => (
              <div key={feature.name}>
                <div>
                  <span className='flex items-center justify-center h-12 w-12 rounded-md bg-white bg-opacity-10'>
                  <div aria-hidden='true'>{ feature.icon }</div>
                  </span>
                </div>
                <div className='mt-6'>
                  <h3 className='text-lg font-medium text-white'>{feature.name}</h3>
                  <p className='mt-2 text-base text-purple-200'>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats section */}
      <div className='relative bg-gray-900'>
        <div className='h-80 absolute inset-x-0 bottom-0 xl:top-0 xl:h-full'>
          <div className='h-full w-full xl:grid xl:grid-cols-2'>
            <div className='h-full xl:relative xl:col-start-2'>
              {/* <img
                className='h-full w-full object-cover opacity-25 xl:absolute xl:inset-0'
                src='https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2830&q=80&sat=-100'
                alt='People working on laptops'
              /> */}
              {/* <div
                aria-hidden='true'
                className='absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r'
              /> */}
            </div>
          </div>
        </div>
        {/* <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8'>
          <div className='relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24'>
            <h2 className='text-sm font-semibold tracking-wide uppercase'>
              <span className='bg-gradient-to-r from-purple-300 to-indigo-300 bg-clip-text text-transparent'>
                Valuable Insight
              </span>
            </h2>
            <p className='mt-3 text-3xl font-extrabold text-white'>
              Get actionable data that will help grow your audience
            </p>
            <p className='mt-5 text-lg text-gray-300'>
              Which blog posts haven’t been shared in a while? Which get the most shares?
            </p>
            <div className='mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2'>
              {metrics.map((item) => (
                <p key={item.id}>
                  <span className='block text-2xl font-bold text-white'>{item.stat}</span>
                  <span className='mt-1 block text-base text-gray-300'>
                    <span className='font-medium text-white'>{item.emphasis}</span> {item.rest}
                  </span>
                </p>
              ))}
            </div>
          </div>
        </div> */}
      </div>

      {/* CTA Section */}
      <div id='join' className='bg-white'>
        <div className='max-w-4xl mx-auto py-16 px-4 sm:px-6 sm:py-48 lg:max-w-7xl lg:px-8 lg:flex lg:items-center lg:justify-between'>
          <h2 className='text-4xl font-extrabold tracking-tight text-gray-900 sm:text-4xl'>
            <span className='block'>Ready for better blog&nbsp;comments?</span>
            <span className='-mb-1 pb-1 block bg-gradient-to-r from-navy-400 to-navy-600 bg-clip-text text-transparent'>
              Get started right now
            </span>
          </h2>
          <div className='mb-5'>
            {/* <SubscribeForm /> */}
            <div className='relative max-w-sm mx-auto'>
              <LinkButton
                href='/start'
                variant='medium'
                color='rose'
                className='max-w-sm my-8 mx-auto text-center'
              >Improve Your Blog in &lt;5 minutes &raquo;</LinkButton>
              <div className='text-[0.75rem] uppercase absolute -bottom-6 text-sky-700 font-bold left-0 right-0 text-center'>
                Start for free
                {/* — No CC required */}
              </div>
            </div>
          </div>
          {/* <div className='mt-6 space-y-4 sm:space-y-0 sm:flex sm:space-x-5'>
            <a
              href='#'
              className='flex items-center justify-center bg-gradient-to-r from-navy-400 to-navy-600 bg-origin-border px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-indigo-600 hover:to-indigo-800 focus:ring-2 focus:ring-offset-2 focus:ring-navy-400 focus:outline-none'
            >
              Learn more
            </a>
            <a
              href='#'
              className='flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-indigo-800 bg-indigo-50 hover:bg-indigo-100'
            >
              Get started
            </a>
          </div> */}
        </div>
      </div>
    </main>

    <footer className='bg-gray-50' aria-labelledby='footer-heading'>
      <h2 id='footer-heading' className='sr-only'>
        Footer
      </h2>
      <div className='max-w-7xl mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-24 lg:px-8'>
        <div className='flex justify-center'>
          <Footer />
          {/* <div className='grid grid-cols-2 gap-8 xl:col-span-2'>
            <div className='md:grid md:grid-cols-2 md:gap-8'>
              <div>
                <h3 className='text-sm font-semibold text-gray-400 tracking-wider uppercase'>Solutions</h3>
                <ul role='list' className='mt-4 space-y-4'>
                  {footerNavigation.solutions.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className='text-base text-gray-700 hover:text-gray-900'>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className='mt-12 md:mt-0'>
                <h3 className='text-sm font-semibold text-gray-400 tracking-wider uppercase'>Pages</h3>
                <ul role='list' className='mt-4 space-y-4'>
                  {footerNavigation.support.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className='text-base text-gray-700 hover:text-gray-900'>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className='md:grid md:grid-cols-2 md:gap-8'>
              <div>
                <h3 className='text-sm font-semibold text-gray-400 tracking-wider uppercase'>Company</h3>
                <ul role='list' className='mt-4 space-y-4'>
                  {footerNavigation.company.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className='text-base text-gray-700 hover:text-gray-900'>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className='mt-12 md:mt-0'>
                <h3 className='text-sm font-semibold text-gray-400 tracking-wider uppercase'>Legal</h3>
                <ul role='list' className='mt-4 space-y-4'>
                  {footerNavigation.legal.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className='text-base text-gray-700 hover:text-gray-900'>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div> */}
          <div className='mb-12 xl:mt-0'>
            {/* <h3 className='text-sm font-semibold text-gray-400 tracking-wider uppercase'>
              Subscribe to our newsletter
            </h3>
            <p className='mt-4 text-base text-gray-700'>
              The latest news, articles, and resources, sent to your inbox weekly.
            </p> */}
          </div>
        </div>
        {/* <div className='mt-12 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between lg:mt-16'>
          <div className='flex space-x-6 md:order-2'>
            {footerNavigation.social.map((item) => (
              <a key={item.name} href={item.href} className='text-gray-400 hover:text-gray-700'>
                <span className='sr-only'>{item.name}</span>
                <div aria-hidden='true'>{ item.icon }</div>
              </a>
            ))}
          </div>
          <p className='mt-8 text-base text-gray-400 md:mt-0 md:order-1'>
            &copy; 2020 Blotter, Inc. All rights reserved.
          </p>
        </div> */}
      </div>
    </footer>
  </div>

export default LandingView

// A silent comment section attracts only silence. Jump-start the dialogue — show Twitter replies as comments on `your blog.'
const reasons = [
  {
    title: 'Empty Comment Sections',
    name: 'Ghost Town',
    // title: 'Ghost Town',
    // name: 'Scary',
    description: <p>
      Let’s be honest: too many blog comment sections sit empty. And <strong>empty blog comment sections scare off potential commenters</strong>.
    </p>,
    blotterBetter: <p>
      <span className='font-bold text-cerise-800'>Blotter is better:</span> Replace empty blog comments by <strong>jumpstarting the convo  on Twitter</strong> and <strong>connecting the threads back</strong> to your blog post.
    </p>,
    href: '#',
    icon: <GhostIcon color={colors.slate[500]} className='h-16 w-16' />,
  },
  {
    title: 'Spam, Spam, and Spam',
    name: 'Spam City',
    // title: 'Spam City',
    // name: 'Sleezy',
    description: <div>
      {/* <p>Somehow this is even worse than the ghost town.</p> */}
      <p>You want to <strong>encourage real discussion</strong>. But often your comments are just spam — drowning out the authentic human voices and undermining any sense of community.</p>
    </div>,
    blotterBetter: <p>
      <span className='font-bold text-cerise-800'>Blotter is better:</span> You’ll get <strong>more authentic comments and less spam</strong>. Soon Blotter will provide advanced moderation tools, too.
    </p>,
    icon: <TrashIcon color={colors.slate[500]} className='h-16 w-16' />,
  },
  {
    title: 'No Visibility, No Distribution',
    name: 'Silent But Deadly',
    description: <div>
      <p>Commenters migrated from blog comment sections to networks like Twitter. Why? Because they get <strong>distribution and visibility</strong>.</p>
      {/* <p>Today, people leave less comments on blogs and more on networks like Twitter — where their friends and colleagues are.</p> */}
      {/* <p>The social network is where there friends and colleagues are. The blog isn’t.</p> */}
      {/* <p>Sadly, that meant no centralization of the comments on your blog — and no sense of community or social proof. Until now.</p> */}
    </div>,
    blotterBetter: <p>
      <span className='font-bold text-cerise-800'>Blotter is better:</span> You get the best of both worlds. <strong>Twitter distribution and visibility</strong> for your commenters, plus <strong>social proof</strong> on your posts and a <strong>sense of community</strong>.
    </p>,
    icon: <EyeOffIcon color={colors.slate[500]} className='h-16 w-16' />,
  },
]
// const reasons = [
//   {
//     name: 'No Crickets',
//     description: <div>
//       <p>An empty comment section sucks.</p>
//       <p>Blotter fills your comments faster AND draws new readers via social sharing.</p>
//       <p>How? Blotter comments are Tweet replies and Tweet replies are Blotter comments!
//         {/* <a className='underline underline-offset-2' href='#how-it-works'>Whaaa?!?</a> */}
//         </p>
//     </div>,
//     href: '#',
//     icon: <LightningBoltIcon color='#fff' className='h-6 w-6' />,
//   },
//   {
//     name: 'No Spam',
//     description: 'Do you like scams in your comments? That’s like inviting a con man to family dinner. Blotter hates spam too.',
//     icon: <TrashIcon className='text-white h-6 w-6' />,
//   },
//   {
//     name: 'No Ads',
//     description: 'Your blog is YOUR blog. You don’t want advertisers putting billboards up there. So Blotter doesn’t.',
//     icon: <CurrencyDollarIcon className='text-white h-6 w-6' />,
//   },
//   {
//     name: 'No Tracking',
//     description: 'The privacy of your users is crucial. Blotter doesn’t track private information. Our analytics stick to the essentials and are aggregate and anonymized.',
//     icon: <EyeIcon className='text-white h-6 w-6' />,
//   },
// ]
// const reasons = [
//   {
//     name: 'The Cold Start',
//     description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus. Et magna sit morbi lobortis.',
//     icon: LightningBoltIcon,
//   },
//   {
//     name: 'SSL Certificates',
//     description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus. Et magna sit morbi lobortis.',
//     icon: TrashIcon,
//   },
//   {
//     name: 'Reply to All',
//     description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus. Et magna sit morbi lobortis.',
//     icon: ReplyIcon,
//   },
// ]


const benefits = [
  // {
  //   name: 'Fast Loading',
  //   description: 'Comments should never weigh down your page. Blotter makes sure they don’t.',
  //   icon: <LightningBoltIcon className='text-cyan-500 w-8 h-8' />,
  // },
  {
    name: 'Mobile-first',
    description: 'Somehow there are still comment systems that don’t work on mobile. Blotter was born on it.',
    icon: <DeviceMobileIcon className='text-cyan-500 w-8 h-8' />,
  },
  {
    name: 'Free while you grow',
    description: 'Just getting started on your growth journey? Save your money until you start making it.',
    icon: <PhotographIcon className='text-cyan-500 w-8 h-8' />,
  },
  {
    name: 'Privacy-friendly',
    description: 'Your readers don’t want to be tracked. Blotter avoids unnecessary data collection.',
    icon: <UsersIcon className='text-cyan-500 w-8 h-8' />,
  },
  {
    name: 'Aggregated Analytics',
    description: 'Blotter shows you which content is working best for you, and what you need to share.',
    icon: <ChartBarIcon className='text-cyan-500 w-8 h-8' />,
  },
  // {
  //   name: 'Social Sharing',
  //   description: 'Many comment systems have social login. Blotter actually shares comments, automatically.',
  //   icon: <ShareIcon className='text-cyan-500 w-8 h-8' />,
  // },
  {
    name: 'Reduced Spam',
    description: 'Spam? Spam?!? Ew. Let’s not do that, okay? You don’t like it and neither do your readers.',
    icon: <TrashIcon className='text-cyan-500 w-8 h-8' />,
  },
  {
    name: 'Easy Access',
    description: 'Commenters don’t want another login. With Blotter, they use their existing Twitter account.',
    icon: <SparklesIcon className='text-cyan-500 w-8 h-8' />,
  },
]
// const metrics = [
//   { id: 1, stat: '8K+', emphasis: 'Companies', rest: 'use laoreet amet lacus nibh integer quis.' },
//   { id: 2, stat: '25K+', emphasis: 'Countries around the globe', rest: 'lacus nibh integer quis.' },
//   { id: 3, stat: '98%', emphasis: 'Customer satisfaction', rest: 'laoreet amet lacus nibh integer quis.' },
//   { id: 4, stat: '12M+', emphasis: 'Issues resolved', rest: 'lacus nibh integer quis.' },
// ]
// const footerNavigation = {
//   // solutions: [
//   //   { name: 'Marketing', href: '#' },
//   //   { name: 'Analytics', href: '#' },
//   //   { name: 'Commerce', href: '#' },
//   //   { name: 'Insights', href: '#' },
//   // ],
//   support: [
//     // { name: 'Support', href: '#' },
//     { name: 'Home', href: '/' },
//     { name: 'Pricing', href: '/pricing' },
//     // { name: 'Documentation', href: '#' },
//     // { name: 'Guides', href: '#' },
//     // { name: 'API Status', href: '#' },
//   ],
//   company: [
//     // { name: 'About', href: '#' },
//     // { name: 'Blog', href: '#' },
//     // { name: 'Press', href: '#' },
//     // { name: 'Partners', href: '#' },
//   ],
//   legal: [
//     // { name: 'Privacy', href: '#' },
//     // { name: 'Terms', href: '#' },
//   ],
// }
